/**
 * Honeybalm Upcart — free gift lines.
 * Upcart renders the drawer itself, so gift rows are found here and tagged with
 * `hb-uc-gift`: hb-upcart.css then hides their remove + quantity controls and
 * this adds a "FREE GIFT" label plus a read-only "Qty: N" line. A row is a gift when its cart line costs 0
 * (matched by variant id in the title link, or by title), or its price shows no
 * amount above zero.
 */
(function () {
  // true: "FREE GIFT" replaces the price + crossed-out price. false: label sits under the title instead.
  var BADGE_IN_PRICE = false;

  var giftVariantIds = {};
  var giftTitles = {};
  var giftQuantities = {};
  var scheduled = false;

  function normalise(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function setGiftsFromCart(cart) {
    giftVariantIds = {};
    giftTitles = {};
    giftQuantities = {};
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item) {
      if (item.final_line_price === 0 || item.line_price === 0) {
        var id = String(item.variant_id);
        giftVariantIds[id] = true;
        giftQuantities[id] = (giftQuantities[id] || 0) + item.quantity;
        giftTitles[normalise(item.product_title)] = true;
        giftTitles[normalise(item.title)] = true;
      }
    });
  }

  function priceIsZero(row) {
    var price = row.querySelector('.upcart-item-price, .styles_ProductRow__ProductPrice__');
    if (!price) return false;
    var clone = price.cloneNode(true);
    clone.querySelectorAll('s, del, [class*="compareAtPrice"]').forEach(function (el) {
      el.remove();
    });
    var text = clone.textContent || '';
    if (/free/i.test(text)) return true;
    return /\d/.test(text) && !/[1-9]/.test(text);
  }

  function isGiftRow(row) {
    var link = row.querySelector('a[href*="variant="]');
    if (link) {
      var match = link.getAttribute('href').match(/variant=(\d+)/);
      if (match && giftVariantIds[match[1]]) return true;
    }
    var title = row.querySelector('.upcart-product-title, .upcart-product-title-link, .styles_ProductRow__productTitle__');
    if (title && giftTitles[normalise(title.textContent)]) return true;
    return priceIsZero(row);
  }

  // Quantity of a gift row: Upcart's (hidden) stepper input first, then the cart data by variant id.
  function giftQuantity(row) {
    var input = row.querySelector('.upcart-product-quantity-input, .styles_quantityInput__, input[type="number"]');
    var value = input ? parseInt(input.value, 10) : 0;
    if (value > 0) return value;
    var link = row.querySelector('a[href*="variant="]');
    var match = link && link.getAttribute('href').match(/variant=(\d+)/);
    return (match && giftQuantities[match[1]]) || 1;
  }

  // The row's outermost wrapper that still holds only this row: its parent is the item list.
  // Gifts are grouped at the top with CSS `order` on that wrapper, so Upcart's DOM is never moved.
  function rowSlot(row) {
    var slot = row;
    while (slot.parentElement && slot.parentElement.id !== 'UpcartPopup' &&
      slot.parentElement.querySelectorAll('.upcart-product-item').length === 1) {
      slot = slot.parentElement;
    }
    return slot;
  }

  function markGifts() {
    scheduled = false;
    document.querySelectorAll('#UpcartPopup .upcart-product-item').forEach(function (row) {
      var gift = isGiftRow(row);
      row.classList.toggle('hb-uc-gift', gift);

      var slot = rowSlot(row);
      slot.classList.toggle('hb-uc-gift-slot', gift);
      if (slot.parentElement) slot.parentElement.classList.add('hb-uc-items');

      var badge = row.querySelector('.hb-uc-gift-badge');
      if (gift && !badge) {
        var anchor = null;
        if (BADGE_IN_PRICE) {
          var price = row.querySelector('.upcart-item-price, .styles_ProductRow__ProductPrice__');
          anchor = price && (price.closest('.styles_ProductRow__price__') || price);
        }
        if (anchor) {
          row.classList.add('hb-uc-gift--price');
        } else {
          anchor = row.querySelector('.upcart-product-title, .upcart-product-title-link, .styles_ProductRow__productTitle__');
        }
        if (!anchor) return;
        badge = document.createElement('span');
        badge.className = 'hb-uc-gift-badge';
        badge.innerHTML =
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20 7h-2.18A3 3 0 0 0 12 3.76 3 3 0 0 0 6.18 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-5-2a1 1 0 1 1 0 2h-2V6a1 1 0 0 1 2-1Zm-6 0a1 1 0 0 1 2 1v1H9a1 1 0 0 1 0-2Zm2 15H7v-8h4Zm0-10H5V9h6Zm6 10h-4v-8h4Zm2-10h-6V9h6Z"/></svg>' +
          'FREE GIFT';
        anchor.insertAdjacentElement(row.classList.contains('hb-uc-gift--price') ? 'beforebegin' : 'afterend', badge);
      } else if (!gift && badge) {
        badge.remove();
        row.classList.remove('hb-uc-gift--price');
      }

      // Read-only quantity under the gift label (the stepper is hidden on gift rows)
      var qty = row.querySelector('.hb-uc-gift-qty');
      if (gift && badge) {
        if (!qty) {
          qty = document.createElement('span');
          qty.className = 'hb-uc-gift-qty';
          badge.insertAdjacentElement('afterend', qty);
        }
        var qtyText = 'Quantity: ' + giftQuantity(row);
        if (qty.textContent !== qtyText) qty.textContent = qtyText;
      } else if (qty) {
        qty.remove();
      }
    });
  }

  // Delivery line under the checkout button: "Order before 1:30 PM and get your order on <date>".
  // US Eastern time decides the date: before the cut-off → DELIVERY_DAYS ahead, after it → one day later; Sunday → Monday.
  // DELIVERY_DAYS = lowest number of the product page delivery time ("1-2 days" → 1).
  var CUTOFF_HOUR = 13;
  var CUTOFF_MINUTE = 30;
  var DELIVERY_DAYS = 1;

  function deliveryDateText() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'America/New_York',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });

    var hour = Number(parts.hour);
    var minute = Number(parts.minute);
    var beforeCutoff = hour < CUTOFF_HOUR || (hour === CUTOFF_HOUR && minute < CUTOFF_MINUTE);
    var date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + DELIVERY_DAYS + (beforeCutoff ? 0 : 1)));
    // No Sunday deliveries: move to Monday
    if (date.getUTCDay() === 0) date.setUTCDate(date.getUTCDate() + 1);
    return date.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'long', day: 'numeric' });
  }

  function addDeliveryLine() {
    var button = document.querySelector('#UpcartPopup .upcart-checkout-button-container, #UpcartPopup .styles_Footer__checkoutButton__');
    if (!button) return;
    var text = 'Order before 1:30 PM and get your order on ';
    var dateText = deliveryDateText();
    var line = button.nextElementSibling;
    if (!line || !line.classList.contains('hb-uc-delivery')) {
      line = document.createElement('p');
      line.className = 'hb-uc-delivery';
      line.innerHTML = '<span class="hb-uc-delivery__dot" aria-hidden="true"></span>' +
        '<span class="hb-uc-delivery__text"><span class="hb-uc-delivery__lead"></span><span class="hb-uc-delivery__date"></span></span>';
      button.insertAdjacentElement('afterend', line);
    }
    // The date sits in its own no-wrap span so the date never splits across lines
    var leadEl = line.querySelector('.hb-uc-delivery__lead');
    var dateEl = line.querySelector('.hb-uc-delivery__date');
    if (leadEl.textContent !== text) leadEl.textContent = text;
    if (dateEl.textContent !== dateText) dateEl.textContent = dateText;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      markGifts();
      addDeliveryLine();
    });
  }

  function observe() {
    var popup = document.getElementById('UpcartPopup');
    if (!popup) return false;
    new MutationObserver(schedule).observe(popup, { childList: true, subtree: true, characterData: true });
    schedule();
    return true;
  }

  window.addEventListener('load', function () {
    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(function (event) {
        setGiftsFromCart(event && event.cart);
        schedule();
      });
    }

    // Upcart injects #UpcartPopup after load; wait for it once, then observe it.
    if (!observe()) {
      var bodyObserver = new MutationObserver(function () {
        if (observe()) bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
